export default [{
  path: '/finance/index',
  name: 'finance-index',
  title: '财务',
  // redirect: '/finance/income',
  component: () => import('@/views/finance/index'),
  children: [{
    path: '/finance/income',
    name: 'finance-income',
    title: '营业统计', // 营业概况
    component: () => import('@/views/finance/template/income/index'),
  }, {
    path: '/finance/record',
    name: 'finance-charge',
    title: '营业统计',
    component: () => import('@/views/finance/template/record/index'),
  }, {
    path: '/finance/performance',
    name: 'finance-performance', // 项目收入
    title: '营业统计',
    component: () => import('@/views/finance/template/performance/index'),
  }, {
    path: '/finance/report',
    name: 'finance-report', // 产品收入
    title: '营业统计',
    component: () => import('@/views/finance/template/report/index'),
  }, {
    path: '/finance/statistics',
    name: 'finance-statistics', // 套餐收入
    title: '营业统计',
    component: () => import('@/views/finance/template/statistics/index'),
  }, {
    path: '/finance/sale',
    name: 'finance-sale', // 快捷收银
    title: '营业统计',
    component: () => import('@/views/finance/template/sale/index'),
  }]
}, {
  path: '/finance/detail',
  name: 'finance-detail',
  title: '详情',
  component: () => import('@/views/finance/template/detail/index'),
}, {
  path: '/finance/analyse',
  name: 'finance-analyse',
  title: '详情',
  component: () => import('@/views/finance/template/bookAnalyse/index'),
}];
